import { Injectable } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root"
})
export class UserService {
  private baseurl = environment.apiConfig.apiUrl;
  private localAgencyID: string;

  constructor(private http: HttpClient) { }

  createAgentUser(formdata): Observable<any> {
    try {
      return this.http.post(this.baseurl + "/users/create-agent", formdata);
      //.subscribe(result => console.log(result));
    } catch (err) {
      this.handleError(err);
    }
  }

  setAgencyID(agencyID: string) {
    this.localAgencyID = agencyID;
  }

  getAgencyID(): string {
    return this.localAgencyID;
  }

  getAgents(agent): Observable<any> {
    try {
      return this.http.get<any>(this.baseurl + "/users/get-agent/" + agent);
    } catch (err) {
      this.handleError(err);
    }
  }

  /*

    116 - Assiston Global Service in Canada LTD.
    117 - St.Bond International Inc.
    172 - Infinity Education

    134,212,320

  */

  getAgentByOID(oid): Observable<any> {
    //change here agencyID for logging in a different agency

    /*
      let param = "212";
      if (this.localAgencyID)
      {
        param = this.localAgencyID;
      }
  
      return from(new Promise((resolve, reject) => resolve(JSON.parse(`{"AgencyID": ${param}, "UserID": "4"}`))));

      */

    try {
      return this.http.get(this.baseurl + "/users/get-agencyID", oid);
    } catch (err) {
      this.handleError(err);
    }
  }

  getAgentAndAgencyID(oid): Observable<any> {
    //change here agencyID for logging in a different agency

    /*
      let param = "212";
      if (this.localAgencyID)
      {
        param = this.localAgencyID;
      }      
  
      return from(new Promise((resolve, reject) => resolve(JSON.parse(`{"AgencyID": ${param}, "UserID": "4", "Company_Name": "Assiston Global Service in Canada LTD."}`))));
  */

    try {
      return this.http.get(this.baseurl + "/users/get-agentID", oid);
    } catch (err) {
      this.handleError(err);
    }
  }

  getCommissionLockedStatus(): Observable<any> {
    // console.log("Environment URL: ", BuildEnvironment.GetEnvironmentUrl());
    try {
      return this.http.get<any>(
        this.baseurl + "/commissions/getCommissionsWindow"
      );
    } catch (err) {
      this.handleError(err);
    }
    // Assuming it returns an obj with a boolean property named "commissionLocked"
    // { commissionLocked: true/false }
  }

  deleteAgent(id: any): Observable<any> {
    try {
      return this.http.delete<any>(this.baseurl + "/users/delete-agent/" + id);
    } catch (err) {
      this.handleError(err);
    }
  }

  private handleError(err: HttpErrorResponse) {
    let errorMessage = "";

    // The backend returned an unsuccessful response code.
    // The response body may contain clues as to what went wrong,
    errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;

    console.error(errorMessage);
    return throwError(() => new Error(errorMessage));
  }
}
